
import { defineComponent, PropType } from '@vue/composition-api';
import IllinoisIcons from './icons.vue';

export interface SelectOption {
  text: string;
  value: string;
}

export default defineComponent({
  name: 'IllinoisSelect',
  components: {
    IllinoisIcons
  },
  props: {
    id: {
      type: String,
      default: () => `select-${Math.random().toString(36).substr(2, 9)}`
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array as PropType<SelectOption[]>,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      hoveredIndex: null as string | null,
      dropdownStyle: {} as Record<string, string>
    };
  },
  computed: {
    selectedText(): string {
      const selected = this.options.find(opt => opt.value === this.value);
      return selected ? selected.text : '';
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleResize, true);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleResize, true);
  },
  methods: {
    toggleDropdown(): void {
      if (this.disabled) return;
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => {
          this.calculateDropdownPosition();
        });
      }
    },
    selectOption(option: SelectOption): void {
      this.$emit('input', option.value);
      this.$emit('change', option.value);
      this.isOpen = false;
    },
    isSelected(val: string): boolean {
      return this.value === val;
    },
    handleClickOutside(event: Event): void {
      const container = this.$refs.selectContainer as HTMLElement;
      if (container && !container.contains(event.target as Node)) {
        this.isOpen = false;
      }
    },
    calculateDropdownPosition(): void {
      const container = this.$refs.selectContainer as HTMLElement;
      const options = this.$refs.optionsContainer as HTMLElement;
      if (!container || !options) return;

      const containerRect = container.getBoundingClientRect();
      const optionsRect = options.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const spaceBelow = viewportHeight - containerRect.bottom;
      const spaceAbove = containerRect.top;

      // Se c'è spazio sotto, mostra il dropdown sotto
      if (spaceBelow >= optionsRect.height || spaceBelow > spaceAbove) {
        this.dropdownStyle = {
          top: '100%',
          left: '0',
          marginTop: '0.25rem'
        };
      } else {
        // Altrimenti mostra sopra
        this.dropdownStyle = {
          bottom: '100%',
          left: '0',
          marginBottom: '0.25rem'
        };
      }
    },
    handleResize(): void {
      if (this.isOpen) {
        this.calculateDropdownPosition();
      }
    }
  }
});
